/*
 * blazingcard
 * version 4.5
 * http://www.blazingcard.com
 *
 * Copyright (c) 2021 Kellton Tech Pvt Ltd
 * Author Kellton Tech Pvt Ltd <support@blazingcard.com>
 * Licensed under the MIT license.
 */

export class BucketdeletefolderForm {
  public folderName: number;

  constructor(bucketdeletefolderForm: any) {
    this.folderName = bucketdeletefolderForm;
  }
}
